export enum MyTicketsStatusEnum {
  UpComingTickets = 'UPCOMMING',
  PastTickets = 'PAST',
}
